export default "__VITE_ASSET__CDMmCl2t__"